/* KTQ "How it folds" widget: crossfading steps with tabs, progress bar, swipe and arrow keys.
   Plain JavaScript, no dependencies. Safe to load more than once. */
(function () {
  'use strict';
  if (window.__ktqFoldLoaded) return;
  window.__ktqFoldLoaded = true;

  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function Fold(root) {
    var self = this;
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    this.steps = this.tabs.map(function (t) { return t.closest('.ktq-fold__step'); });
    this.media = root.querySelector('.ktq-fold__media');
    if (this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;

    this.interval = Math.max(1500, (parseFloat(root.getAttribute('data-interval')) || 3.5) * 1000);
    this.autoplayWanted = root.getAttribute('data-autoplay') !== 'false';
    this.index = 0;
    this.elapsed = 0;
    this.last = 0;
    this.raf = 0;
    this.stopped = false;     // user clicked/used keys/swiped: no more auto-play
    this.hovering = false;
    this.focusing = false;
    this.touching = false;
    this.visible = true;
    this.pageVisible = !document.hidden;

    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { self.userSelect(i, false); });
      tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
    });
    root.addEventListener('mouseenter', function () { self.hovering = true; self.sync(); });
    root.addEventListener('mouseleave', function () { self.hovering = false; self.sync(); });
    root.addEventListener('focusin', function () { self.focusing = true; self.sync(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { self.focusing = false; self.sync(); }
    });
    this.bindSwipe();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        self.sync();
      }, { threshold: 0.25 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      self.pageVisible = !document.hidden;
      self.sync();
    });
    if (reduceQuery) {
      var onChange = function () { self.sync(); };
      if (reduceQuery.addEventListener) reduceQuery.addEventListener('change', onChange);
      else if (reduceQuery.addListener) reduceQuery.addListener(onChange);
    }

    this.show(0, false);
    this.sync();
  }

  Fold.prototype.canPlay = function () {
    return this.autoplayWanted && !this.stopped && !(reduceQuery && reduceQuery.matches) &&
      !this.hovering && !this.focusing && !this.touching && this.visible && this.pageVisible;
  };

  Fold.prototype.sync = function () {
    var shouldPlay = this.canPlay();
    var noAuto = !this.autoplayWanted || this.stopped || (reduceQuery && reduceQuery.matches);
    this.root.classList.toggle('is-static', !!noAuto);
    if (shouldPlay && !this.raf) {
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.tick.bind(this));
    } else if (!shouldPlay && this.raf) {
      cancelAnimationFrame(this.raf);
      this.raf = 0;
    }
  };

  Fold.prototype.tick = function (now) {
    this.raf = 0;
    if (!this.canPlay()) return;
    this.elapsed += now - this.last;
    this.last = now;
    if (this.elapsed >= this.stepLength()) {
      this.show((this.index + 1) % this.tabs.length, false);
    } else {
      this.paint();
    }
    this.raf = requestAnimationFrame(this.tick.bind(this));
  };

  Fold.prototype.stepLength = function () {
    var v = this.panels[this.index].querySelector('video');
    if (v && v.duration && isFinite(v.duration)) return Math.max(this.interval, v.duration * 1000);
    return this.interval;
  };

  /* Videos: muted, inline; only the active step's video plays (from the start) */
  Fold.prototype.playVideos = function () {
    var self = this;
    this.panels.forEach(function (p, n) {
      var v = p.querySelector('video');
      if (!v) return;
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', '');
      if (n === self.index && !(reduceQuery && reduceQuery.matches)) {
        try { v.currentTime = 0; } catch (e) {}
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      } else {
        v.pause();
      }
    });
  };

  Fold.prototype.paint = function () {
    var bar = this.tabs[this.index].querySelector('.ktq-fold__bar i');
    if (bar) bar.style.transform = 'scaleX(' + Math.min(1, this.elapsed / this.stepLength()).toFixed(4) + ')';
  };

  Fold.prototype.show = function (i, focus) {
    var self = this;
    this.index = i;
    this.elapsed = 0;
    this.tabs.forEach(function (tab, n) {
      var on = n === i;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      self.panels[n].classList.toggle('is-active', on);
      if (self.steps[n]) self.steps[n].classList.toggle('is-active', on);
      var bar = tab.querySelector('.ktq-fold__bar i');
      if (bar) bar.style.transform = 'scaleX(0)';
    });
    if (focus) this.tabs[i].focus();
    this.playVideos();
  };

  Fold.prototype.userSelect = function (i, focus) {
    this.stopped = true;
    this.show(i, focus);
    this.sync();
  };

  Fold.prototype.onKey = function (e, i) {
    var n = this.tabs.length, next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next === null) return;
    e.preventDefault();
    this.userSelect(next, true);
  };

  Fold.prototype.bindSwipe = function () {
    var self = this, x0 = 0, y0 = 0, tracking = false;
    var el = this.media;
    if (!el) return;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true;
      self.touching = true;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      self.sync();
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      self.touching = false;
      if (tracking && e.changedTouches.length) {
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          var n = self.tabs.length;
          self.userSelect(dx < 0 ? (self.index + 1) % n : (self.index - 1 + n) % n, false);
        }
      }
      tracking = false;
      self.sync();
    }, { passive: true });
    el.addEventListener('touchcancel', function () { tracking = false; self.touching = false; self.sync(); }, { passive: true });
  };

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-ktq-fold]');
    Array.prototype.forEach.call(list, function (root) {
      if (root.__ktqFold) return;
      root.__ktqFold = new Fold(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  /* Shopify theme editor: re-run when a section is added or reloaded */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
